import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "layers",
  "use": "layers-usage",
  "viewBox": "0 0 54.953 54.953",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 54.953 54.953\" id=\"layers\"><path d=\"M45.297 21.946l9.656-5.517L27.477.825 0 16.429l9.656 5.517L0 27.429l9.656 5.517L0 38.429l27.477 15.698 27.476-15.698-9.656-5.483 9.656-5.517-9.656-5.483zM27.477 3.125l23.435 13.309-23.435 13.39-23.436-13.39L27.477 3.125zM11.675 23.099l15.802 9.028 15.802-9.028 7.633 4.335-23.435 13.39-23.436-13.39 7.634-4.335zm39.237 15.335l-23.435 13.39-23.436-13.39 7.634-4.335 15.802 9.028 15.802-9.028 7.633 4.335z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/layers.svg
// module id = YGh9
// module chunks = 1